import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AllReportComponent } from './all-report.component';
import { FormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';




const routes: Routes = [
  { 
    path:'', 
    component:AllReportComponent
  }
];

@NgModule({
  declarations: [AllReportComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    NgxDatatableModule
  ]
})
export class AllReportModule { }
